import "@fortawesome/fontawesome-free/js/all";
import Rails from "@rails/ujs";
import {createRoot} from "react-dom/client";
import "lib/shakapacker-asset-fix";

export default function setup({Component}) {
  Rails.start();

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".react-component").forEach((node) => {
      const props = JSON.parse(node.getAttribute("data"));
      const root = createRoot(node);

      root.render(<Component {...props} />);
    });
  });
}
